<template>
  <hic-dialog v-loading="loading" @open="open" append-to-body :close-on-click-modal="false" title="导出小治疗单" :visible="visible" width="30rem" top="30vh" @close="close()">
    <div style="margin-top:20px;margin-bottom:20px">病区：<hic-dict-selector v-model="condition.wardCode" dict-type="IpWard" placeholder="请选择" class="condition-input" size="small"></hic-dict-selector>
    </div>
    导出类目：
    <el-checkbox-group v-model="keywords" style="margin-top:10px">
      <el-checkbox v-for="type in types" :label="type" :key="type">{{type}}</el-checkbox>
    </el-checkbox-group>
    <div style="margin-top:20px;margin-bottom:10px">
      请输入额外需要导出的类目名称，多个类目名称用逗号【,】连接
      <el-input v-model="extra"></el-input>
    </div>

    <div slot="footer">
      <el-button type="primary" size="large" @click="exportExcel">导 出</el-button>
      <el-button type="info" size="large" @click="close()">关 闭</el-button>
    </div>
  </hic-dialog>
</template>

<script>
import { mapGetters } from "sw-hic";
import api from "./api";
export default {
  props: {
    visible: Boolean
  },
  data() {
    return {
      loading: false,
      condition: {
        wardCode: null,
        keyword: null,
      },
      types: [],
      keywords: [],
      extra: '',
    };
  },
  computed: {
    ...mapGetters(["setting"]),
  },
  methods: {
    open() {
      this.keywords = this.setting.treatmentExportKeyword.split(',');
      this.types = this.setting.treatmentExportKeyword.split(',');
    },
    exportExcel() {
      let selectKeyword = [];
      this.types.forEach(type => {
        if (this.keywords.includes(type)) {
          selectKeyword.push(type);
        }
      })
      if (this.extra.trim()) {
        selectKeyword.push(this.extra.trim());
      }

      this.condition.keyword = selectKeyword.join(',');
      if (!this.condition.keyword) {
        this.$message.error('请选择类目或输入类目名称！');
        
        return;
      }

      this.loading = true;
      api.ExportExcel.downloadTreatment(this.condition).then((res) => {
        this.$message.success("导出小治疗单成功！");
      }).finally(() => {
        this.loading = false;
      });
    },
    close() {
      this.$emit('update:visible', false);
    }
  }
}
</script>